var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-overlay',{key:"overlay-loading",attrs:{"value":_vm.isLoading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"red"}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }